const API_VER = 'v1.0'
const API_VER_V2 = 'v2.0'
const API_ANALYTICS_VER = 'v1.0'
export const ATTEndpoints = {
    ATT_PRESENT_SUMMARY_TODAY: `/att/api/${API_VER}/absent_summary/`,
    ATT_EMPLOYEE_PRESENT_STATUS_URI: `/att/api/${API_VER}/records/current_day_list/`,
    ATT_TIMESHEET_URI: `/att/api/${API_VER_V2}/timesheet_ngteco/`,
    ATT_ATTENDANCE_SETTING_URI: `/att/api/${API_VER}/timesheet_ngteco/setting/`,
    ATT_UPDATE_SETTING_URI: `/att/api/${API_VER}/timesheet_ngteco/update_setting/`,
    ATT_GET_DATE_RANGE_URI: `/att/api/${API_VER}/attendance_timeralo/get_date_range/`,
    ATT_SCHEDULE_URI: `/att/api/${API_VER}/schedules_ngteco/`,
    ATT_SCHEDULE_URI_CALC: `/att/api/${API_VER}/schedules_ngteco/calc_by_manual/`,
    ATT_SCHEDULE_URI_BULK_DELETE: `/att/api/${API_VER}/schedules_ngteco/bulk_delete/`,
    ATT_PUNCH_RECORD_URI: `/att/api/${API_VER}/records/aggregation_list/`,
    ATT_TRANSACTION_URI: `/att/api/${API_VER}/transactions/transaction/`,
    ATT_TRANSACTION_DOWNLOAD_URI: `/att/api/${API_VER}/transactions/download/`,
    ATT_MANUAL_LOG_URI: `/att/api/${API_VER_V2}/manuallog/manual_log/`,
    ATT_APPROVAL_URI: `/att/api/${API_VER_V2}/manuallog/`,
    ATT_PUNCH_RECORD_ADD_URI: `/att/api/${API_VER_V2}/records/`,
    ATT_TIMECARD_URI: `/att/api/${API_VER}/timecard/`,
    ATT_TIMECARD_URI_ADVANCED: `/att/api/${API_VER_V2}/timecard/advanced_list/`,
    ATT_TIMECARD_URI_ADVANCED_DOWNLOAD: `/att/api/${API_VER_V2}/timecard/advanced_download/`,
    ATT_REPORT_FIRST_LAST: `/att/report/api/${API_VER}/first_last/`,
    ATT_REPORT_FILO: `/att/report/api/${API_VER}/filo/`,
    ATT_REPORT_MONTHLY_REPORT: `/att/report/api/${API_VER}/monthly/`,
    ATT_REPORT_ATTENDANCE_REPORT: `/att/report/api/${API_VER}/attendance/`,
    ATT_REPORT_OVERTIME_ANALYSIS: `/att/report/api/${API_VER}/overtime_analysis/`,
    ATT_COLLECTION_RULE: `/att/api/${API_VER}/collection_rule/`,

    MOBILE_LOCATION_DETAIL: `/mobile/api/${API_VER}/location/`,
    MOBILE_LOCATION_ADD: `/mobile/api/${API_VER}/location/add_location/`,
    MOBILE_LOCATION_EDIT: `/mobile/api/${API_VER}/location/edit_location/`,

    // Workforce Analytics Dashboard (base path: /api/)
    ANALYTICS_OVERTIME_TREND: `/att/report/api/${API_VER}/employee_overtime/dashboard_trend/`,
    ANALYTICS_EMPLOYEE_TREND: `/att/report/api/${API_VER}/employee_overtime/dashboard_employees/`,
    ANALYTICS_EMPLOYEES_OVERTIME: `/att/report/api/${API_VER}/employee_overtime/`,
}
